
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/examples/counters",
      function () {
        return require("private-next-pages/examples/counters.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/examples/counters"])
      });
    }
  